import { Colour, Tag, TagSizeEnum } from '@ukpostbox/frontend-framework';
import { MailTagType } from '../Types/MailTagTypes';

function MailTagOverflowed(props: MailTagType) {
	return (
		<Tag id={-1000} name={`+ ${props.tagCount} Tags`} size={TagSizeEnum.Small} colour={Colour.Secondary} hideIcon />
	);
}

export { MailTagOverflowed };
